import dayjs from 'dayjs'

import { nullDate } from '@/libs/helpers'

export const formatDate = (date: Date | number | string, showTime = false) => {
    const formatToken = showTime ? 'DD.MM.YYYY, HH:mm' : 'DD.MM.YYYY'
    return dayjs(date).format(formatToken)
}

export const isDateNull = (date: Date | number | string) => {
    return dayjs(date).format('YYYY-MM-DD') === nullDate
}

export default dayjs
